<template>
  <el-col
    class="content"
    :xl="{ span: 18 }"
    :lg="{ span: 18 }"
    :md="{ span: 18 }"
    :xs="{ span: 24 }"
    :sm="{ span: 24 }"
  >
    <div class="mydoc">
      <div class="header" style="font-weight: 900">【实验语言学】投稿指南</div>
      <div class="mybody">
        <p>
          本刊主要刊登以物理、生理、心理、以及脑科学的实验方法进行的普通语言学和专语语言学研究、语言应用研究以及多语言比较研究等方面的论文。本刊将开设专题研究目探讨一些重要的理论和方法问题。
        </p>
        <p>
          1.投稿方式：网上投稿。来稿请使用在线投稿系统http://www.exp-linguistics.com注册账号投寄电子本。不再寄送纸质打印本。
        </p>
        <p>
          2.稿件要求 (1) 使用语言：中文（简体字、繁体字）、英文、日文皆可。 (2)
          稿件构成： A．作者信息页（含合著者信息，通讯作者请注明）
          论文题目；作者姓名；任职单位、职务、职称；联系方式（邮编、邮寄地址、电话号码、电子邮址）。
          B．论文部分
          论文题目；论文提要和关键词；论文正文；注释；参考文献；论文原始数据。
          C．非英文稿请附英文题目、英文提要（500词）和关键词，以便于检索。
        </p>
        <p>
          3.论文版面
          (1)使用A4页面，中文8页以内，原则上8000字左右，英文和日文12页以内。重要文章可以酌情放宽。
          (2)标题：中文四号黑体（14p），日文MSゴシック（14p），英文Times New
          Roman（14p）。标题下空两行。
          (3)正文：中文为五号宋体（10.5p），日文为MS明朝体（10.5p），英文为Times
          New
          Roman（12p）。图表序号一排到底（如：图1、图2……；表1、表2……）图表一般在6-8个。国际音标用方括号[
          ]。 (4)注释用①②③编序码。中文为小五号宋体(9p)，日文为MS明朝体(9p)，
          英文为Times New Roman（10p）。
          (5)“参考文献”四字中文用小五号黑体(9p)，日文用MSゴシック体(9p)，英文用Times
          New
          Roman体（10p）。顶格。所列文献，中文为小五号宋体(9p)，日文为MS明朝体(9p)，英文为Times
          New
          Roman体（10p）。每条另起一行，顶格。按中文、英文、日文归类排列。顺序为作者、年份、题目、发表刊物（注明卷数、期数、页数）或出版社。
        </p>
        <p>4.论文模板下载。</p>
        <el-row>
          <el-col
            :span="12"
            style="cursor: pointer; color: #006a71"
            @click.native="downloadChinese()"
            >中文模板下载</el-col
          >

          <el-col
            :span="12"
            style="cursor: pointer; color: #006a71"
            @click.native="downloadEnglish()"
            >英文模板下载</el-col
          >
        </el-row>
      </div>
    </div>
  </el-col>
</template>>

<script>
import loginComponent from "@/components/loginComponent";

export default {
  name: "guidelines",
  components: {
    loginComponent,
  },
  data() {
    return {};
  },
  methods: {
    downloadChinese() {
      window.open(
        "http://www.exp-linguistics.com/file/%E8%AE%BA%E6%96%87%E6%A8%A1%E6%9D%BF.docx",
        "_blank"
      );
    },
    downloadEnglish() {
      window.open(
        "http://www.exp-linguistics.com/file/英文论文模板.docx",
        "_blank"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.el-row {
  //   background-color: white;
  margin: auto;
}

.introduction_pre {
  width: auto;
  margin: 10px 5px 10px 5px; /**边框距离 上右边下左 */
  background-color: white;
  overflow: hidden;
}
.introduction {
  border: 1px solid #b3c0d1;
  height: 920px;
  margin-bottom: 10px;
  border-radius: 5px;
  /* margin-top: 5px; */
}

.about {
  min-height: calc(100vh - 8rem);
}
.showappbox {
  display: flex;
  .left {
    text-align: left;
  }
}

.content {
  margin-top: 12px;
  .mylink {
    height: 18rem;
    border-radius: 4px;
    background: rgba($color: #ffffff, $alpha: 0.5);
    box-shadow: 2px 3px 10px rgb(51, 72, 94);
    .mybody {
      //   padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .body-item {
        cursor: pointer;
      }
      .num {
        font-size: 55px;
        font-weight: bold;
      }
    }
  }
  .mydoc {
    border-radius: 4px;
    min-height: 20rem;
    box-shadow: 2px 3px 10px rgb(51, 72, 94);
    text-align: left;
    .mybody {
      //   background: linear-gradient(45deg, #34495e, #41b883);
      height: 940px;
      padding: 10px;
      background-color: white;
      overflow: auto;
    }
    p {
      color: black;
      text-indent: 30px;
      line-height: 24px;
      padding: 10px;
    }
  }
}
.header {
  padding: 10px;
  text-align: left;
  background-color: gainsboro;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom: 1px solid gainsboro;
}
</style>


// WEBPACK FOOTER //
// src/view/guidelines.vue